import { Fade, Slide, SlideProps } from '@mui/material';
import Alert, { AlertProps } from '@mui/material/Alert';
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';

export interface SnackbarOptions {
  /**
   * The message to display.
   */
  message?: React.ReactNode;
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity?: AlertProps['severity'];
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action?: SnackbarProps['action'];
  /**
   * - [Snackbar API](https://mui.com/material-ui/api/snackbar/)
   */
  snackbarProps?: SnackbarProps;
  /**
   * - [Alert API](https://mui.com/material-ui/api/alert/)
   * - inherits [Paper API](https://mui.com/material-ui/api/paper/)
   */
  alertProps?: AlertProps;

  onClose?: () => void;
}

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

export const Snack: React.FC<SnackbarOptions> = ({
  message,
  severity,
  alertProps,
  snackbarProps,
  action,
  onClose
}) => {
  const [state, setState] = React.useState<{
    open: boolean;
    Transition: React.ComponentType<
      TransitionProps & {
        children: React.ReactElement<any, any>;
      }
    >;
  }>({
    open: false,
    Transition: Fade
  });
  alertProps = { ...alertProps, severity, action };
  snackbarProps = { ...snackbarProps, message };

  return (
    <Snackbar
      {...snackbarProps}
      autoHideDuration={2000}
      onClose={onClose}
      TransitionComponent={SlideTransition}
    >
      <Alert {...alertProps}>{snackbarProps?.message}</Alert>
    </Snackbar>
  );
};
